<nav class="crumbs" aria-label="Breadcrumb">
  <ol>
    <li>
      <a routerLink="/">
        <svg class="crumbs-home" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M3 10.5 12 3l9 7.5" />
          <path d="M5 9.8V21h14V9.8" />
        </svg>
        <span>Home</span>
      </a>
    </li>
    @for (crumb of trail(); track crumb.label; let last = $last) {
      <li>
        <svg class="crumbs-sep" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor"
          stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m9 18 6-6-6-6" />
        </svg>
        @if (crumb.url && !last) {
          <a [routerLink]="[crumb.url]">{{ crumb.label }}</a>
        } @else {
          <span class="crumbs-current" aria-current="page">{{ crumb.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
